import React from 'react';
import './styles.css';

function handleChange(evt, callback, val) {
  const event = evt;
  event.target.value = val;
  callback(event);
}

export default ({options, value, onChange, style = {}}) => (
    <div className="buttongroup">
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
            <button style={style} type={'button'} key={`opt-${opt.value}`}
                    disabled={opt.disabled}
                    className={`buttongroup-button${isActive ?
                        ' is-active' :
                        ''}`}
                    onClick={e => handleChange(e, onChange, opt.value)}
            >
              {opt.label}
            </button>
        );
      })}
    </div>
);
